import { Modal, Spin } from "antd";
import { bool, func, number, string } from "prop-types";
import { FormattedMessage } from "react-intl";

const ConfirmModal = ({
  headerTitleKey,
  hidden,
  onSaveChanges,
  toggle,
  loading,
  bodyTextKey,
  additionalBodyText,
  cancelLabel,
}) => (
  <Modal
    title={<FormattedMessage id={headerTitleKey} />}
    open={!hidden}
    cancelText={cancelLabel || <FormattedMessage id={"general.no"} />}
    okText={<FormattedMessage id={"general.yes"} />}
    onOk={onSaveChanges}
    onCancel={() => toggle(true)}
    okButtonProps={{
      loading: loading,
    }}
  >
    {loading ? (
      <Spin />
    ) : (
      <p>
        <FormattedMessage id={bodyTextKey} /> {additionalBodyText}
      </p>
    )}
  </Modal>
);

ConfirmModal.propTypes = {
  onSaveChanges: func.isRequired,
  toggle: func.isRequired,
  hidden: bool.isRequired,
  headerTitleKey: string.isRequired,
  bodyTextKey: string.isRequired,
  additionalBodyText: string,
  loading: bool,
  confirmationTimeoutSeconds: number,
  cancelLabel: string,
};

export default ConfirmModal;
